<p-toast position="top-right" key="cargo-details-message"></p-toast>

<div [class.divider-bottom]="cargoDetailsForm?.controls.length > 1" class="p-py-3"
     *ngFor="let cargoForm of cargoDetailsForm?.controls; let i = index">
    <div class="p-text-right p-pb-2">
        [{{i + 1}} / {{cargoDetailsForm?.controls?.length}}]
    </div>
    <div [formGroup]="cargoForm">

        <div class="p-mt-3">
            <div class="p-grid p-ai-center p-jc-between width-100">
                <div class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-field">
                        <label> Cargo Type </label>
                        <p-dropdown [options]="containerTypesArray" appendTo="body"
                                    emptyMessage="Cargo Types Not Found"
                                    [disabled]="isPreviewSI"
                                    formControlName="cargoType"
                                    optionLabel="containerDescription"
                                    optionValue="containerId"
                                    placeholder="Select..."
                                    styleClass="si-dropdown">
                        </p-dropdown>
                    </div>
                </div>
                <div *ngIf="cargoForm?.value?.cargoType === 'Live Animal'"
                     class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-d-flex p-jc-between p-ai-center">
                        <div>
                            <h5 class="p-m-0" style="opacity: .7;"> Upload Document (PDF
                                Only)</h5>
                            <small class="p-text-warning">Max Filesize: 20MB</small>
                        </div>
                        <div>
                            <!--LIVE_ANIMAL_DOCUMENT-->
                            <p-fileUpload #fileUploadLiveAnimal [customUpload]="true" [class.p-d-none]="isPreviewSI"
                                          [invalidFileSizeMessageDetail]="'File size is greater than 20MB'"
                                          [invalidFileSizeMessageSummary]="'Invalid File Size'"
                                          [maxFileSize]="2e+7"
                                          [disabled]="isPreviewSI || siAction === 'add'"
                                          (uploadHandler)="emitSiDocumentsForUpload('LIVE_ANIMAL_DOCUMENT', $event, cargoForm?.value, fileUploadLiveAnimal)"
                                          accept="application/pdf"
                                          chooseIcon="pi pi-upload"
                                          class="fp-file-upload"
                                          mode="basic"
                                          styleClass="p-button-secondary"></p-fileUpload>
                        </div>
                    </div>
                    <div class="p-pt-2 p-text-secondary">
                        {{fileUploadLiveAnimal?._files[0]?.name ?
                        'Selected File : ' + fileUploadLiveAnimal?._files[0]?.name : (cargoForm.value?.liveAnimalDocument ? 'Uploaded File : ' + cargoForm.value?.liveAnimalDocument?.name : '')}}
                    </div>
                </div>

                <div *ngIf="cargoForm.value.cargoType === 'Hazardous'"
                     class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-d-flex p-jc-between p-ai-center">
                        <div>
                            <h5 class="p-m-0" style="opacity: .7;"> MSDS (PDF Only)</h5>
                            <small class="p-text-warning">Max Filesize: 20MB</small>
                        </div>
                        <div>

                            <!--MSDS Pdf Uploader-->

                            <p-fileUpload #fileUploadMSDS [customUpload]="true" [class.p-d-none]="isPreviewSI"
                                          [invalidFileSizeMessageDetail]="'File size is greater than 20MB'"
                                          [invalidFileSizeMessageSummary]="'Invalid File Size'"
                                          [maxFileSize]="2e+7"
                                          [disabled]="isPreviewSI || siAction === 'add'"
                                          (uploadHandler)="emitSiDocumentsForUpload('MSDS_DOCUMENT', $event, cargoForm?.value, fileUploadMSDS)"
                                          [uploadLabel]="'Upload'"
                                          accept="application/pdf"
                                          chooseIcon="pi pi-plus"
                                          uploadIcon="pi pi-upload"
                                          class="fp-file-upload"
                                          mode="basic"
                                          styleClass="p-button-secondary"></p-fileUpload>

                        </div>
                    </div>

                    <div class="p-pt-2 p-text-secondary">
                        {{fileUploadMSDS?._files[0]?.name ?
                        'Selected File : ' + fileUploadMSDS?._files[0]?.name : (cargoForm.value?.msdsDocument ? 'Uploaded File : ' + cargoForm.value?.msdsDocument?.name : '')}}
                    </div>

                </div>

                <div *ngIf="cargoForm.value.cargoType === 'Automobile'"
                     class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-d-flex p-jc-between p-ai-center">
                        <div>
                            <h5 class="p-m-0" style="opacity: .7;"> ATA Carnet (PDF
                                Only)</h5>
                            <small class="p-text-warning">Max Filesize: 20MB</small>
                        </div>
                        <div>
                            <!--Ata Carnet Pdf Uploader-->
                            <p-fileUpload #fileUploadAta [customUpload]="true" [class.p-d-none]="isPreviewSI"
                                          [invalidFileSizeMessageDetail]="'File size is greater than 20MB'"
                                          [invalidFileSizeMessageSummary]="'Invalid File Size'"
                                          [maxFileSize]="2e+7"
                                          [disabled]="isPreviewSI || siAction === 'add'"
                                          [uploadLabel]="'Upload'"
                                          accept="application/pdf"
                                          (uploadHandler)="emitSiDocumentsForUpload('ATA_CARNET_DOCUMENT', $event, cargoForm?.value, fileUploadAta)"
                                          chooseIcon="pi pi-upload"
                                          class="fp-file-upload"
                                          mode="basic"
                                          styleClass="p-button-secondary"></p-fileUpload>
                        </div>
                    </div>

                    <div class="p-pt-2 p-text-secondary">
                        {{fileUploadAta?._files[0]?.name ?
                        'Selected File : ' + fileUploadAta?._files[0]?.name : (cargoForm.value?.ataCarnetDocument ? 'Uploaded File : ' + cargoForm.value?.ataCarnetDocument?.name : '')}}
                    </div>
                </div>
            </div>
        </div>

        <div class="p-mt-1">
            <div class="p-grid p-ai-center width-100">
                <div class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-field">
                        <label> Commodity* </label>
                        <p-autoComplete (completeMethod)="completeCommodities($event)"
                                        (input)="getCommoditiesByPrefix($event)"
                                        [emptyMessage]="'No Commodities Found'"
                                        [showEmptyMessage]="true"
                                        [suggestions]="filteredCommodities"
                                        appendTo="body"
                                        field="commodityDescription"
                                        formControlName="commodity"
                                        placeholder="Type at-least 3 characters"
                                        styleClass="width-100 si-autocomplete"

                        ></p-autoComplete>
                    </div>
                </div>

                <div class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-field">
                        <label> Kind of Packages * </label>
                        <p-dropdown [options]="kindOfPackages" [placeholder]="'Select...'"
                                    appendTo="body"
                                    emptyMessage="No packages found"
                                    filter="true"
                                    filterBy="packageDescription"
                                    formControlName="kindOfPackage"
                                    optionLabel="packageDescription"
                                    optionValue="packageCode"
                                    styleClass="si-dropdown"></p-dropdown>
                    </div>
                </div>

                <div class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-field">
                        <label> Number of Packages * </label>
                        <p-inputNumber [max]="10000"
                                       [min]="1"
                                       [showButtons]="!isPreviewSI"
                                       formControlName="numberOfPackage"
                                       styleClass="width-100 si-container-number"></p-inputNumber>
                    </div>
                </div>

                <div class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-field">
                        <label> Volume (m3) * </label>
                        <input class="width-100" formControlName="volume" pInputText
                               type="number">
                    </div>
                </div>

            </div>
        </div>

        <div class="p-mt-3">
            <div class="p-grid p-ai-center width-100">
                <div class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-d-flex p-ai-center p-pr-2">
                        <div class="width-100">
                            <div class="p-field">
                                <label> {{cargoForm?.value?.cargoType === 'Live Animal' ? 'Cage Length' : 'Length'}} </label>
                                <input [disabled]="isPreviewSI"
                                       [formControl]="cargoForm?.value?.cargoType === 'Live Animal' ? cargoForm?.get('cageLength') : cargoForm?.get('length')"
                                       class="width-100"
                                       pInputText
                                       type="number">
                            </div>
                            <!--                                                        [formControlName]="cargoDetailForm.value.cargoType === 'Live Animal' ? 'cageLength' : 'length'"-->
                        </div>
                        <div>
                            <div class="p-field">
                                <label> &nbsp; </label>
                                <p-dropdown [disabled]="isPreviewSI"
                                            [formControlName]="cargoForm?.value?.cargoType === 'Live Animal'  ? 'cageLengthUOM' : 'lengthUOM'"
                                            [formControl]="cargoForm?.value?.cargoType === 'Live Animal' ? cargoForm?.get('cageLengthUOM') : cargoForm?.get('lengthUOM')"
                                            [options]="measureUnit"
                                            appendTo="body"
                                            emptyMessage="No units found"
                                            styleClass="si-dropdown units-dropdown p-ml-2"></p-dropdown>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-d-flex p-ai-center p-pr-2">
                        <div class="width-100">
                            <div class="p-field">
                                <label> {{cargoForm?.value?.cargoType === 'Live Animal' ? 'Cage Width' : 'Width'}} </label>
                                <input [disabled]="isPreviewSI"
                                       [formControl]="cargoForm?.value?.cargoType === 'Live Animal' ? cargoForm?.get('cageWidth') : cargoForm?.get('width')"
                                       class="width-100"
                                       pInputText
                                       type="number">
                            </div>
                        </div>
                        <div>
                            <div class="p-field">
                                <label> &nbsp; </label>
                                <p-dropdown
                                        [disabled]="isPreviewSI"
                                        [formControl]="cargoForm?.value?.cargoType === 'Live Animal' ? cargoForm?.get('cageWidthUOM') : cargoForm?.get('widthUOM')"
                                        [options]="measureUnit"
                                        appendTo="body"
                                        emptyMessage="No units found"
                                        styleClass="si-dropdown units-dropdown p-ml-2"></p-dropdown>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-d-flex p-ai-center p-pr-2">
                        <div class="width-100">
                            <div class="p-field">
                                <label> {{cargoForm?.value?.cargoType === 'Live Animal' ? 'Cage Height' : 'Height'}} </label>
                                <input [formControl]="cargoForm?.value?.cargoType === 'Live Animal' ? cargoForm?.get('cageHeight') : cargoForm?.get('height')"
                                       class="width-100"
                                       pInputText
                                       type="number">
                            </div>
                        </div>
                        <div>
                            <div class="p-field">
                                <label> &nbsp; </label>
                                <p-dropdown
                                        [disabled]="isPreviewSI"
                                        [formControl]="cargoForm?.value?.cargoType === 'Live Animal' ? cargoForm?.get('cageHeightUOM') : cargoForm?.get('heightUOM')"
                                        [options]="measureUnit"
                                        appendTo="body"
                                        emptyMessage="No units found"
                                        styleClass="si-dropdown units-dropdown p-ml-2"></p-dropdown>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-d-flex p-ai-center p-pr-2">
                        <div class="width-100">
                            <div class="p-field">
                                <label> Gross Weight* </label>
                                <input class="width-100" formControlName="grossWeight"
                                       pInputText
                                       type="number">
                            </div>
                        </div>
                        <div>
                            <div class="p-field">
                                <label> &nbsp; </label>
                                <p-dropdown [options]="weightUnit"
                                            [disabled]="isPreviewSI"
                                            appendTo="body"
                                            emptyMessage="No units found"
                                            formControlName="grossWeightUOM"
                                            styleClass="si-dropdown units-dropdown p-ml-2"></p-dropdown>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="p-mt-3">
            <div class="p-grid p-ai-center width-100">
                <div class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-d-flex p-ai-center p-pr-2">
                        <div class="width-100">
                            <div class="p-field">
                                <label> Chargeable Weight </label>
                                <input [disabled]="isPreviewSI" class="width-100" formControlName="chargeableWeight"
                                       pInputText
                                       type="number">
                            </div>
                        </div>
                        <div>
                            <div class="p-field">
                                <label> &nbsp; </label>
                                <p-dropdown [options]="weightUnit"
                                            appendTo="body"
                                            [disabled]="isPreviewSI"
                                            emptyMessage="No units found"
                                            formControlName="chargeableWeightUOM"
                                            styleClass="si-dropdown units-dropdown p-ml-2"></p-dropdown>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="cargoForm?.value.cargoType === 'Perishable'"
                     class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-field">
                        <label> Required Temperature * </label>
                        <input [disabled]="isPreviewSI" class="width-100" formControlName="temperature" pInputText
                               type="text">
                    </div>
                </div>

                <div *ngIf="cargoForm?.value.cargoType === 'Automobile'"
                     class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-field">
                        <label> Wheel Base Dimension </label>
                        <input class="width-100" formControlName="wheelBaseDimension" pInputText
                               type="text">
                    </div>
                </div>

                <div *ngIf="cargoForm?.value.cargoType === 'Hazardous'"
                     class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-field">
                        <label> IMCO Number * </label>
                        <input [disabled]="isPreviewSI" class="width-100" formControlName="imcoClass" pInputText
                               type="text"
                        >
                    </div>
                </div>

                <div *ngIf="cargoForm?.value.cargoType === 'Hazardous'"
                     class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-field">
                        <label> UN Number * </label>
                        <input [disabled]="isPreviewSI" class="width-100" formControlName="unNumber" pInputText
                               type="text"
                        >
                    </div>
                </div>

                <div *ngIf="cargoForm?.value.cargoType === 'Hazardous'"
                     class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-field">
                        <label> Type of UN Packing * </label>
                        <input [disabled]="isPreviewSI" class="width-100" formControlName="typeOfUnPacking" pInputText
                               type="text">
                    </div>
                </div>

            </div>
        </div>

    </div>
</div>

